import { Action } from '@ngrx/store';

export const ConsentErrorKeys = {
  TermsOfUseConsentTextId: 'TermsOfUseConsentTextId',
  PrivacyPolicyConsentTextId: 'PrivacyPolicyConsentTextId',
  AiDisclaimerConsentTextId: 'AiDisclaimerConsentTextId',
};

export const mapValidationErrorsToActions = (
  error: any,
  mapping: Record<string, Action>
): Action[] => {
  if (error?.errors && typeof error.errors === 'object') {
    return Object.keys(error.errors)
      .map((key) => mapping[key])
      .filter((action): action is Action => !!action);
  }
  return [];
};
